import { PrefetchLink } from "@boundary/components/prefetchLink";
import styles from "./menuFooter.module.scss";

// Версия обновляется вручную при значимых изменениях
// Формат: major.minor.HHMM-DDMMYY
const APP_VERSION = "1.1.0809-230126";

export function MenuFooter() {
  return (
    <div className={styles.container}>
      <PrefetchLink to="/profile">Юридическая информация</PrefetchLink>
      <p>Версия: {APP_VERSION}</p>
    </div>
  );
}

